@import "config";

.dashedButton {
	border-style: dashed !important;
	border-color: $color-light-l2 !important;
	width: 100%;
	padding: $spacing-inline-sm !important;
}
